import cn from 'classnames';
import { useLayoutEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';

import { APP_ID, AppRoutes } from './utils/constants';

import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import { AccessibilityProvider } from './contexts/AccessibilityContext';
import useDeviceTypeDetector from './hooks/useDeviceTypeDetector/useDeviceTypeDetector';
import CourseDetails from './pages/CourseDetails/CourseDetails';
import Courses from './pages/Courses/Courses';
import EntrepreneurSchool from './pages/EntrepreneurSchool/EntrepreneurSchool';
import FreeConsultationPage from './pages/FreeConsultationPage/FreeConsultationPage';
import Home from './pages/Home/Home';

import './assets/styles/index.scss';
import useScrollToHash from './hooks/useScrollToHash';
import Search from './pages/Search/Search';
import { DeviceTypeEnum } from './utils/enums';
import OrgInfo from './pages/OrgInfo/OrgInfo';

function App() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const { deviceType } = useDeviceTypeDetector();

  const setBodyClass = () => {
    Object.values(DeviceTypeEnum).forEach((c) => document.body.classList.remove(c));
    document.body.classList.add(deviceType);
  };

  useScrollToHash();
  useLayoutEffect(setBodyClass, [deviceType]);

  return (
    <AccessibilityProvider>
      <div id={APP_ID} className={cn('application', isDrawerOpen && 'drawer-open')}>
        <Header isDrawerOpen={isDrawerOpen} onDrawerOpenChange={setIsDrawerOpen} />
        <Routes>
          <Route path={AppRoutes.home} element={<Home />} />
          <Route path={AppRoutes.courses} element={<Courses />} />
          <Route path={AppRoutes.school} element={<EntrepreneurSchool />} />
          <Route path={`${AppRoutes.courses}/:course`} element={<CourseDetails />} />
          <Route path={AppRoutes.freeConsultation} element={<FreeConsultationPage />} />
          <Route path={AppRoutes.search} element={<Search />} />
          <Route path={AppRoutes.orgInfo} element={<OrgInfo />} />
        </Routes>
        <Footer />
      </div>
    </AccessibilityProvider>
  );
}

export default App;
